// removed by extract-text-webpack-plugin
module.exports = {"box":"box_PoliticsFooter","gallery":"gallery_PoliticsFooter","item":"item_PoliticsFooter","image":"image_PoliticsFooter","label":"label_PoliticsFooter","license-list":"license-list_PoliticsFooter","licenseList":"license-list_PoliticsFooter","list":"list_PoliticsFooter","link":"link_PoliticsFooter","police":"police_PoliticsFooter","hotline":"hotline_PoliticsFooter","item-box":"item-box_PoliticsFooter","itemBox":"item-box_PoliticsFooter"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PoliticsFooter/PoliticsFooter.scss
// module id = 289
// module chunks = 0